import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SharedModule } from '../../shared.module';

@Component({
  selector: 'app-input-chips',
  standalone: true,
  imports: [SharedModule,],
  templateUrl: './input-chips.component.html',
  styleUrl: './input-chips.component.scss'
})
export class InputChipsComponent {

  @Output() valueChange: EventEmitter<string[]> = new EventEmitter();
  control: FormControl = new FormControl();
  chips: string[] = [];

  addChipValue(event: any) {
    this.chips.push(event.target.value)
    this.valueChange.emit(this.chips)
    event.target.value = ''
  }

  removeChip(index: number) {
    this.chips.splice(index, 1);
    this.valueChange.emit(this.chips)
  }
}
